import _asyncToGenerator from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/Users/n8/Development/NFT My Monstera/code/.build/websites/moodymonsteras.com/node_modules/@babel/runtime/regenerator/index.js";
import { useWeb3React } from '@web3-react/core';
import { useCallback } from 'react';
import { useConfig } from '../providers/config/context';
import { InjectedConnector } from '@web3-react/injected-connector';
export function useEthers() {
  var result = useWeb3React();

  var _useConfig = useConfig(),
      networks = _useConfig.networks;

  var activateBrowserWallet = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(onError, throwErrors) {
      var injected;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              injected = new InjectedConnector({
                supportedChainIds: networks === null || networks === void 0 ? void 0 : networks.map(function (network) {
                  return network.chainId;
                })
              });

              if (!(onError instanceof Function)) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return result.activate(injected, onError, throwErrors);

            case 4:
              _context.next = 8;
              break;

            case 6:
              _context.next = 8;
              return result.activate(injected, undefined, throwErrors);

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), [networks]);
  return Object.assign(Object.assign({}, result), {
    activateBrowserWallet: activateBrowserWallet
  });
}